import qs from 'qs';
import React from 'react';

import type { SearchState } from '../collections/searchStateUrlStorageHelpers';

/**
 * Function to update searchRef from URL query strings.
 */
export const updateSearchRefFromUrl = (searchRef: React.MutableRefObject<SearchState>) => {
  if (!searchRef) return;
  searchRef.current = qs.parse(window.location.search.slice(1)) as SearchState;
};

export const getCollectionHandleFromPath = (pathname: string) => {
  const pathSegments = pathname.split('/').filter(Boolean);
  const collectionsSegmentIndex = pathSegments.indexOf('collections');
  return collectionsSegmentIndex >= 0 ? pathSegments[collectionsSegmentIndex + 1] || '' : '';
};
